import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from './lib/sentry'
import { initMixpanel } from './lib/analytics'
import { initializeThemeOnBootstrap } from './features/theme/preferences/useThemePreferences'
import { initializeLanguageOnBootstrap } from './features/language/preferences/useLanguagePreferences'

initSentry()
initMixpanel()
initializeThemeOnBootstrap()
initializeLanguageOnBootstrap()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
